import { getData } from "../utils";

export async function getSettings(chainId) {
  try {
    const response = await getData(`/api/v1/get_chain_data?chainId=${chainId}`);    
    const settings = response.data.settings.reduce(
      (previousValue, currentValue) => {
        previousValue[currentValue.key] = currentValue.val;
        return previousValue;
      },
      {} // Initial value set to an empty object
    );
    return settings;
  } catch (err) {
    return Promise.reject(err);
  }
}